import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';

import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'components/Dropdown2';
import Message from 'components/Message';

import {
  SCHEDULE_LIST_FILTER,
  SCHEDULE_LIST_FILTER_OPTIONS,
  SCHEDULE_LIST_FILTER_OPTION_KEYS,
  DEFAULT_SCHEDULE_LIST_FILTER,
} from './ScheduleList.helpers';

const messages = defineMessages({
  label: {
    id: 'yield-management.schedule-list.schedule-list-filter.label',
    defaultMessage: 'Type',
  },
  allClasses: {
    id: 'yield-management.schedule-list.schedule-list-filter.all-classes',
    defaultMessage: 'All classes',
  },
  classesWithReservations: {
    id: 'yield-management.schedule-list.schedule-list-filter.classes-with-reservations',
    defaultMessage: 'Classes with reservations',
  },
  recommendations: {
    id: 'yield-management.schedule-list.schedule-list-filter.recommendations',
    defaultMessage: 'Recommendations',
  },
  disabled: {
    id: 'yield-management.schedule-list.schedule-list-filter.disabled',
    defaultMessage: 'Disabled',
  },
});

const messagesByFilter = {
  [SCHEDULE_LIST_FILTER.ALL_CLASSES]: messages.allClasses,
  [SCHEDULE_LIST_FILTER.CLASSES_WITH_RESERVATIONS]: messages.classesWithReservations,
  [SCHEDULE_LIST_FILTER.RECOMMENDATIONS]: messages.recommendations,
  [SCHEDULE_LIST_FILTER.DISABLED]: messages.disabled,
};

function ScheduleListFilter(props) {
  const { selectedFilterKey, setScheduleListFilter } = props;
  const isLegacyFilterKey = SCHEDULE_LIST_FILTER_OPTION_KEYS.includes(selectedFilterKey);
  const displayFilterKey = isLegacyFilterKey ? selectedFilterKey : DEFAULT_SCHEDULE_LIST_FILTER;
  const isActive = displayFilterKey !== DEFAULT_SCHEDULE_LIST_FILTER;

  useEffect(() => {
    if (!isLegacyFilterKey) {
      setScheduleListFilter(DEFAULT_SCHEDULE_LIST_FILTER);
    }
  }, [isLegacyFilterKey, setScheduleListFilter]);

  return (
    <Dropdown attachment="left" dataCypress="schedule-list-filter">
      <DropdownToggle label={messages.label} isActive={isActive}>
        <Message id={displayFilterKey} messages={messagesByFilter} />
      </DropdownToggle>
      <DropdownMenu>
        {SCHEDULE_LIST_FILTER_OPTIONS.map(({ key }) => (
          <DropdownItem
            key={`schedule-list-filter-${key}`}
            isSelected={key === displayFilterKey}
            onClick={() => setScheduleListFilter(key)}>
            <Message id={key} messages={messagesByFilter} />
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}

ScheduleListFilter.propTypes = {
  selectedFilterKey: PropTypes.string,
  setScheduleListFilter: PropTypes.func,
};

export default ScheduleListFilter;
